import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IImage) {
    (function(Type) {
        Type["PRODUCT"] = "PRODUCT";
        Type["PACKAGING"] = "PACKAGING";
        Type["LIFESTYLE"] = "LIFESTYLE";
        Type["DEFAULT_BRAND"] = "DEFAULT_BRAND";
        /**
     * A squared image for a brand with a light color pallete.
     */ Type["LIGHT_TILE"] = "LIGHT_TILE";
        /**
     * A squared image for a brand with a medium color pallete.
     */ Type["MEDIUM_TILE"] = "MEDIUM_TILE";
        /**
     * A squared image for a brand with a dark color pallete.
     */ Type["DARK_TILE"] = "DARK_TILE";
        /**
     * A landing page image for brand partnerships with a light color palette.
     */ Type["LIGHT_WHOLESALE_PORTAL_LANDING"] = "LIGHT_WHOLESALE_PORTAL_LANDING";
        /**
     * A landing page image for brand partnerships with a dark color palette.
     */ Type["DARK_WHOLESALE_PORTAL_LANDING"] = "DARK_WHOLESALE_PORTAL_LANDING";
        /**
     * A signup page image for brand partnerships with a light color palette.
     */ Type["LIGHT_WHOLESALE_PORTAL_SIGNUP"] = "LIGHT_WHOLESALE_PORTAL_SIGNUP";
        /**
     * A signup page image for brand partnerships with a dark color palette.
     */ Type["DARK_WHOLESALE_PORTAL_SIGNUP"] = "DARK_WHOLESALE_PORTAL_SIGNUP";
        /**
     * Can be the hero image for a displayable entity. Each entity can have at most one Hero image.
     */ Type["HERO"] = "HERO";
        Type["MOBILE"] = "MOBILE";
        Type["DESKTOP"] = "DESKTOP";
        Type["TABLET"] = "TABLET";
        Type["XLARGE_DESKTOP"] = "XLARGE_DESKTOP";
        /**
     * Used to show that the type of this image is represented as a tag
     */ Type["TAGGED"] = "TAGGED";
    })(IImage.Type || (IImage.Type = {}));
    (function(ICropParameters) {
        (function(FormFactor) {
            FormFactor["FORM_FACTOR_UNKNOWN"] = "FORM_FACTOR_UNKNOWN";
            FormFactor["SQUARE_TILE"] = "SQUARE_TILE";
            FormFactor["APPAREL_RECTANGULAR_TILE"] = "APPAREL_RECTANGULAR_TILE";
            FormFactor["BANNER_IMAGE"] = "BANNER_IMAGE";
            FormFactor["PROFILE_IMAGE"] = "PROFILE_IMAGE";
        })(ICropParameters.FormFactor || (ICropParameters.FormFactor = {}));
        (function(Source) {
            Source["SOURCE_UNKNOWN"] = "SOURCE_UNKNOWN";
            Source["BRAND_USER_SPECIFIED"] = "BRAND_USER_SPECIFIED";
            Source["ADMIN_USER_SPECIFIED"] = "ADMIN_USER_SPECIFIED";
            Source["AUTO_GENERATED_DATA_SCIENCE"] = "AUTO_GENERATED_DATA_SCIENCE";
        })(ICropParameters.Source || (ICropParameters.Source = {}));
        ICropParameters.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IImage.ICropParameters || (IImage.ICropParameters = {}));
    IImage.build = function(partial) {
        return _object_spread({
            tags: [],
            crop_parameters: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IImage || (IImage = {}));
export var IImage;
